export default __webpack_public_path__ + "static/media/demoGirl.5a383113.svg";